import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="fixed bottom-0 z-40 w-full border-t border-slate-200 bg-white/80 backdrop-blur">
      <div className="flex items-center justify-center gap-2 py-1.5">
        <button
          type="button"
          className="cursor-pointer font-Nunito text-xs font-medium text-slate-500 transition-colors hover:text-dca-blue"
          onClick={(e) => {
            e.preventDefault();
            navigate("/cgu");
          }}
        >
          CGU
        </button>
        <span aria-hidden="true" className="text-slate-300">
          •
        </span>
        <p className="font-Nunito text-xs text-slate-400">
          © 2026 — Tous droits réservés
        </p>
      </div>
    </footer>
  );
};

export default Footer;
